module.exports = __webpack_public_path__ + "img/88.9.TU.85bb7fd1.png";